import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FIELD_ERROR_MESSAGES, firstErrorMessageKey } from '../field-error-messages';

/**
 * Translated message of the first validation error of `control`.
 * Use it on a `mat-error` that is a direct child of `mat-form-field` (a wrapper element would not be
 * projected into the error slot):
 *
 *     <mat-error [appFieldErrors]="form.controls.name"/>
 *
 * The form field shows it only while the control is touched and invalid.
 * `messages` overrides the default error key -> i18n key map.
 */
@Component({
    standalone: true,
    selector: 'mat-error[appFieldErrors]',
    imports: [TranslateModule],    template: `{{ messageKey | translate }}`
})
export class FieldErrorsComponent {
    @Input({ required: true, alias: 'appFieldErrors' }) control!: AbstractControl;
    @Input() messages: Readonly<Record<string, string>> = FIELD_ERROR_MESSAGES;

    get messageKey(): string {
        return firstErrorMessageKey(this.control.errors, this.messages) ?? '';
    }
}
